(() => {
  'use strict';
  const bar = document.querySelector('.dc-enquiry-bar,.ds-enquiry-bar');
  const hero = document.querySelector('.dc-hero,.ds-hero,.dt-editorial--hero') || document.querySelector('main h1')?.closest('header,section');
  const primary = hero?.querySelector('.dc-btn--green,.dt-care-article__button,a[href*="/pages/prendre-rendez-vous"],a[href*="/pages/inscription"]');
  const mobileQuery = window.matchMedia('(max-width:749px)');
  document.body.classList.add('dt-float-managed');
  let frame = 0;
  function visible(element, bottom = window.innerHeight) {
    if (element.hidden || element.getAttribute('aria-hidden') === 'true' || element.closest('details:not([open])')) return false;
    const style = getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 90 && rect.top < bottom;
  }
  const update = () => {
    frame = 0;
    const mobile = mobileQuery.matches;
    const previewRect = document.getElementById('PBarNextFrame')?.getBoundingClientRect();
    const previewOffset = previewRect && previewRect.height > 0 && previewRect.bottom >= window.innerHeight - 2 ? (previewRect.height > 160 ? 80 : Math.max(0, window.innerHeight - previewRect.top)) : 0;
    document.body.style.setProperty('--dt-preview-offset', `${Math.ceil(previewOffset)}px`);
    const passedAction = primary ? primary.getBoundingClientRect().bottom <= 80 : hero ? hero.getBoundingClientRect().bottom <= 0 : window.scrollY > window.innerHeight;
    const focusedInput = Boolean(document.activeElement?.matches('input:not([type="hidden"]),textarea,select,[contenteditable="true"]'));
    const keyboardOpen = mobile && window.visualViewport && window.innerHeight - window.visualViewport.height > 150;
    const inputActive = mobile && (focusedInput || keyboardOpen);
    const modalOpen = [...document.querySelectorAll('dialog[open],[aria-modal="true"],menu-drawer details[open]')].some(element => visible(element));
    const formVisible = [...document.querySelectorAll('main form')].some(element => visible(element, window.innerHeight - previewOffset));
    const active = Boolean(bar && passedAction && !inputActive && !modalOpen && !formVisible && (bar.classList.contains('dc-enquiry-bar') || mobile));
    if (bar && bar.hidden !== !active) bar.hidden = !active;
    document.body.classList.toggle('dt-input-active', Boolean(inputActive));
    document.body.classList.toggle('dt-enquiry-active', active);
    document.body.classList.toggle('dc-enquiry-active', active && bar?.classList.contains('dc-enquiry-bar'));
    const clearance = active ? (parseFloat(getComputedStyle(bar).bottom) || 0) + bar.getBoundingClientRect().height + 12 : previewOffset + 12;
    document.body.style.setProperty('--dt-obstacle-bottom', `${Math.ceil(clearance)}px`);
    document.body.style.setProperty('--dc-float-bottom', `${Math.ceil(clearance)}px`);
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  ['scroll', 'resize', 'pageshow', 'focusin', 'focusout'].forEach(event => window.addEventListener(event, schedule, { passive: true }));
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  if ('ResizeObserver' in window) {
    const sizes = new ResizeObserver(schedule);
    if (bar) sizes.observe(bar);
    if (hero) sizes.observe(hero);
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden'] });
  update();
})();
